// JS events for Service Link Page
export function initializeServiceLink() {
  // service link, toggle modal
  const openModalTriggers = document.querySelectorAll('[data-open-modal]');

  if (openModalTriggers) {
    openModalTriggers.forEach((modalTrigger) => {
      const modalId = modalTrigger.dataset.openModal;
      const modalElement = document.querySelector(`#${modalId}`);

      modalTrigger.addEventListener('click', () => {
        if (modalElement) {
          modalElement.classList.remove('modal--hidden');
        }
      });
    });
  }

  const closeModalTriggers = document.querySelectorAll('[data-close-modal]');

  if (closeModalTriggers) {
    closeModalTriggers.forEach((modalTrigger) => {
      const modalId = modalTrigger.dataset.closeModal;
      const modalElement = document.querySelector(`#${modalId}`);

      modalTrigger.addEventListener('click', (e) => {
        if (e.target.dataset.closeModal) {
          if (modalElement) {
            modalElement.classList.add('modal--hidden');
          }
        }
      });
    });
  }

  const closeModalButtonTriggers = document.querySelectorAll(
    '[data-close-modal-button]'
  );

  if (closeModalButtonTriggers) {
    closeModalButtonTriggers.forEach((modalTrigger) => {
      const modalId = modalTrigger.dataset.closeModalButton;
      const modalElement = document.querySelector(`#${modalId}`);

      modalTrigger.addEventListener('click', (e) => {
        modalElement.classList.add('modal--hidden');
      });
    });
  }

  // multiple upload, submit form
  let uploadFiles = [];
  let submitEnabled = true;
  const responseForm = document.querySelector('#replyForm form');

  if (responseForm) {
    responseForm.addEventListener('submit', (e) => {
      e.preventDefault();

      if (!submitEnabled) {
        return;
      }

      if (!responseForm.checkValidity()) {
        return;
      }

      responseForm.classList.add('form--submitting');

      submitEnabled = false;

      const formBody = new window.FormData(responseForm);
      const responseDocumentFiles = uploadFiles;

      for (let i = 0; i < responseDocumentFiles.length; i++) {
        formBody.append(
          'ResponseDocument' + (i + 1),
          responseDocumentFiles[i],
          responseDocumentFiles[i].name
        );
      }

      formBody.append('upload_file', 'true');
      formBody.append('ajax', '1');

      let headers = new window.Headers();
      headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Accept', 'application/json');
      headers.append('Content-Type', 'application/json');

      window
        .fetch(responseForm.getAttribute('action'), {
          method: responseForm.getAttribute('method'),
          body: formBody,
        })
        .then(() => {
          submitEnabled = true;

          // add success message to url
          const url = new URL(window.location.href);
          url.searchParams.set('success', 'true');

          window.location.href = url.href;
        });
    });
  }

  // multipleUploadList
  const uploadInput = document.getElementById(
    'UserResponseForm_UserResponseForm_ResponseDocuments'
  );

  if (uploadInput) {
    uploadInput.addEventListener('change', (e) => {
      for (let i = 0; i < uploadInput.files.length && i < 5; ++i) {
        uploadFiles.push(uploadInput.files[i]);
      }

      renderFileList();
    });
  }

  const renderFileList = () => {
    var output = document.getElementById('multipleUploadList');
    var children = '';

    for (let i = 0; i < uploadFiles.length && i < 5; ++i) {
      children += `<div class="step__upload">
          <span class="step__file">
            <img class="step__fileicon" src="_resources/themes/bos/images/file.png" />
            <span class="step__filename">${uploadFiles[i].name}</span>
            <span class="step__remove step__remove-file" data-filename="${uploadFiles[i].name}">
              <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
                <g stroke="#333" strokeWidth="2.56" fill="none" fillRule="evenodd" strokeLinecap="round">
                  <path d="M1.333 1.333l7.008 7.008M8.667 1.333L1.659 8.341" />
                </g>
              </svg>
            </span>
          </span>
        </div>`;
    }

    if (output) {
      output.innerHTML = children;
    }

    const removeFileTrigger = document.querySelectorAll(
      'span.step__remove-file'
    );

    if (removeFileTrigger) {
      removeFileTrigger.forEach((removeFileElement) => {
        removeFileElement.addEventListener('click', (e) => {
          const fileName = e.currentTarget?.dataset.filename;
          uploadFiles = uploadFiles.filter((item) => item.name !== fileName);
          renderFileList();
        });
      });
    }
  };
}
